import React from "react";
import { Container } from "@chakra-ui/react";
import ListBotTemplate from "views/admin/BotTemplate/components/ListBotTemplate";

const BotTemplate = () => {
  return (
    <Container maxW="xxl" mt={100} p={{ base: 4, md: 8 }}>
      <ListBotTemplate />
    </Container>
  );
};

export default BotTemplate;
